import React, { useContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { ProfileSection } from "../../context/ProfileContext";
import {
  getFolio,
  getSupportTypeList,
  getSupportMine,
  logoutApi,
} from "../../api";
import { setFolio, setSupportTypeList, setSupportMine } from "../../redux";
import { SettingFullScreenButton } from "./SettingFullScreenButton";
import { useTranslation } from "react-i18next";
import { 
  FiSun, 
  FiMoon, 
  FiHelpCircle, 
  FiLock, 
  FiShield, 
  FiBookOpen, 
  FiHeadphones, 
  FiFileText, 
  FiLogOut, 
  FiArrowLeft, 
  FiMonitor,
  FiGlobe
} from "react-icons/fi";

const SettingComp = (props) => {
  const { t, i18n } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [theme, setTheme] = useState("light");
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const isRTL = i18n.language === "fa" || i18n.language === "ar";
  const direction = isRTL ? "rtl" : "ltr";

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    // Apply theme to HTML root element
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.body.setAttribute("data-theme", savedTheme);
    // Also apply to any wrapper element
    const appWrapper = document.querySelector(".app-wrapper");
    if (appWrapper) appWrapper.setAttribute("data-theme", savedTheme);
  }, []);

  const howToUseClicked = () => {
    window.open("https://mmaviot.com/setup/", "_blank");
  };

    const privacy_page = () => {
    window.open("https://mmaviot.com/privacy/", "_blank");
  };


      const Terms_and_Conditions_page = () => {
    window.open("https://mmaviot.com/terms/", "_blank");
  };


  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    
    // Apply theme to ALL elements
    document.documentElement.setAttribute("data-theme", newTheme);
    document.body.setAttribute("data-theme", newTheme);
    
    // Apply to any wrapper elements
    const appWrapper = document.querySelector(".app-wrapper");
    if (appWrapper) appWrapper.setAttribute("data-theme", newTheme);
    
    // Force CSS variables to update
    document.documentElement.style.setProperty('--theme-transition', 'all 0.3s ease');
  };

  // Language change function
  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    
    // Force page reload to apply RTL/LTR changes
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const supportClicked = () => {
    ProfileShowHideFunc("contactUs");
    getSupportTypeList(token)
      .then((res) => {
        dispatch(setSupportTypeList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
    getSupportMine(token)
      .then((res) => {
        dispatch(setSupportMine(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const logOut = () => {
    logoutApi(token)
      .then(() => {
        Cookies.remove("token");
        props.history.push("/");
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const menuItems = [
    { 
      key: "fullscreen", 
      label: t("نمایش تمام صفحه"), 
      icon: <FiMonitor size={18} />, 
      component: <SettingFullScreenButton />, 
      isComponent: true 
    },
    { 
      key: "theme", 
      label: t("تم"), 
      icon: theme === "light" ? <FiMoon size={18} /> : <FiSun size={18} />, 
      onClick: toggleTheme 
    },
    { 
      key: "language", 
      label: t("زبان"), 
      icon: <FiGlobe size={18} />, 
      isLanguage: true 
    },
    { 
      key: "help", 
      label: t("راهنما"), 
      icon: <FiHelpCircle size={18} />, 
      onClick: howToUseClicked 
    },
    { 
      key: "changePassword", 
      label: t("فراموشی رمز عبور"), 
      icon: <FiLock size={18} />, 
      onClick: () => ProfileShowHideFunc("changePassPage") 
    },
    { 
      key: "privacy",
      label: t("حریم خصوصی"), 
      icon: <FiShield size={18} />, 
      onClick: privacy_page 
    },

    { 
      key: "support", 
      label: t("پشتیبانی"), 
      icon: <FiHeadphones size={18} />, 
      onClick: supportClicked 
    },
    { 
      key: "terms", 
      label: t("شرایط و قوانین"), 
      icon: <FiFileText size={18} />, 
      onClick: Terms_and_Conditions_page 
    },
    { 
      key: "logout", 
      label: t("خروج"), 
      icon: <FiLogOut size={18} />, 
      onClick: logOut 
    },
  ];

  return (
    <div className="setting-container" style={{ direction: direction }}>
      <h2 className="setting-title">{t("تنظیمات")}</h2>
      
      <div>
        {menuItems.map((item, index) => (
          <div key={index}>
            {item.isLanguage ? (
              // Language selector with two buttons
              <div className="setting-language-item">
                <div className="setting-item-label">
                  <FiGlobe size={18} style={{ marginLeft: "8px" }} />
                  {item.label}
                </div>
                <div className="language-buttons">
                  <button
                    className={`language-btn ${currentLanguage === "fa" ? "active" : ""}`}
                    onClick={() => changeLanguage("fa")}
                  >
                    فارسی
                  </button>
                  <button
                    className={`language-btn ${currentLanguage === "en" ? "active" : ""}`}
                    onClick={() => changeLanguage("en")}
                  >
                    English
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="setting-item"
                onClick={item.onClick}
                style={{ cursor: "pointer" }}
              >
                <span className="setting-item-label">{item.label}</span>
                <div className="setting-item-icon">
                  {item.isComponent ? item.component : item.icon}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <button
        className="setting-back-btn"
        onClick={() => ProfileShowHideFunc("firstPage")}
      >
        <FiArrowLeft size={18} />
        <span>{t("بازگشت")}</span>
      </button>
    </div>
  );
};

const Setting = withRouter(SettingComp);

export { Setting };